<template>
  <header class="pdf-header mb-3">
    <div class="d-flex justify-space-between">
      <div class="d-flex">
        <div>
          <CodaLogo />
        </div>
        <div class="ml-2">
          <h3>{{ warehouse?.name }}</h3>
          <ul class="pdf-header__information pl-0">
            <li>{{ warehouse?.address.line1 || '-' }}</li>
            <li>
              {{
                `${warehouse?.address.city}, ${warehouse?.address.state?.name} ${warehouse?.address.zipCode}`
              }}
            </li>
            <li>Phone: {{ warehouse?.contacts[0]?.phoneNumber || '-' }}</li>
            <li>www.coda-usa.com</li>
          </ul>
        </div>
      </div>
      <div class="flex grow-0 gap-x-6">
        <div class="flex justify-space-between flex-col">
          <v-chip v-if="headload" class="self-end" color="#625FFF1A">
            <img width="20" :src="HeadLoadIndicator" alt="headload" />
            <span class="ml-2">HEADLOAD</span>
          </v-chip>
          <div v-if="hazardous" class="text-right mt-auto grow-0 flex">
            <img width="64" height="64" src="@/assets/img/hazard.png" alt="hazard" />
            <h1 class="h-fit">
              HAZARDOUS <br />
              CARGO
            </h1>
          </div>
        </div>
        <div>
          <h3 class="gray-solid--text text-end text-uppercase">{{ title }}</h3>
          <div class="d-flex justify-end">
            <img width="141" src="@/assets/img/bar-code.png" alt="bar-code" />
          </div>
          <h3 class="font-weight-bold text-end">{{ subTitle }}</h3>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import CodaLogo from '@/components/view/CodaLogo.vue';
import { useOrganizationStore } from '@/store/modules/useOrganizationStore';
import HeadLoadIndicator from '@/assets/img/icons/indicators/headload-indicator.svg';

export default defineComponent({
  name: 'HeaderPDF',
  components: {
    CodaLogo,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      default: '',
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    totalPages: {
      type: Number,
      default: 1,
    },
    hazardous: {
      type: Boolean,
      default: false,
    },
    headload: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const organizationStore = useOrganizationStore();
    const warehouse = computed(() => organizationStore.currentWarehouse);

    return { warehouse, HeadLoadIndicator };
  },
});
</script>

<style lang="scss">
.pdf-header {
  font-family: 'Helvetica', sans-serif;
  &__information {
    padding: 0;
    list-style: none;
  }
}
</style>
